import {Component} from '@angular/core';
import {Store} from '@ngrx/store';
import * as fromRoot from '../reducers';
import * as actions from '../actions/authentication';
import {Observable} from 'rxjs/Observable';

@Component({
  selector: 'error-message',
  template: `
    <div *ngIf="showError$ | async" class="app-error-display alert alert-danger" (click)="close()">
      {{message$ | async}}
    </div>
    <div *ngIf="showSuccess$ | async" class="app-error-display alert alert-success" (click)="close()">
      {{message$ | async}}
    </div>
  `,
  styles: [`
  .app-error-display {
    width: 500px;
    position: fixed; 
    top: 7px; 
    left: 100%; 
    margin-left: -510px;
    z-index: 9999!important;
    cursor: pointer;
  }
  `]
})
export class ErrorMessageComponent {
  public showError$: Observable<boolean>;
  public message$: Observable<string>;
  public showSuccess$: Observable<boolean>;

  constructor(private store: Store<fromRoot.State>) {
    this.showError$ = this.store.select(fromRoot.getIsError);
    this.showSuccess$ = this.store.select(fromRoot.getIsSuccess);
    this.message$ = this.store.select(fromRoot.getMessage);
  }

  close() {
    this.store.dispatch(new actions.HideMessageAction());
  }
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/components/error-message.ts